import { AdvancedArticleCreateEditFormData } from 'mk2/apps/blogs/components/AdvancedArticleCreateEditForm';
import { Option } from 'mk2/components/forms/SelectField';
import { FormPageType } from 'mk2/constants/enums';
import { PhotosUploadConfig, UploadedPhoto } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Add item

export const ADVANCED_ARTICLE_CREATE_EDIT_ADD_ITEM_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_ADD_ITEM_TRIGGER';
export interface AdvancedArticleCreateEditAddItemTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_ADD_ITEM_TRIGGER;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly listIdx: number;
}
export const advancedArticleCreateEditAddItemTrigger =
    (username: string, articlePostSlug: string, listIdx: number): AdvancedArticleCreateEditAddItemTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_ADD_ITEM_TRIGGER, username, articlePostSlug, listIdx,
    });

///////////////////////////////////////////////////////////////////
// Add list

export const ADVANCED_ARTICLE_CREATE_EDIT_ADD_LIST_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_ADD_LIST_TRIGGER';
export interface AdvancedArticleCreateEditAddListTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_ADD_LIST_TRIGGER;
    readonly username: string;
    readonly articlePostSlug: string;
}
export const advancedArticleCreateEditAddListTrigger =
    (username: string, articlePostSlug: string): AdvancedArticleCreateEditAddListTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_ADD_LIST_TRIGGER, username, articlePostSlug,
    });

///////////////////////////////////////////////////////////////////
// Remove item

export const ADVANCED_ARTICLE_CREATE_EDIT_REMOVE_ITEM_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_REMOVE_ITEM_TRIGGER';
export interface AdvancedArticleCreateEditRemoveItemTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_REMOVE_ITEM_TRIGGER;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly listIdx: number;
    readonly itemIdx: number;
}
export const advancedArticleCreateEditRemoveItemTrigger =
    (username: string, articlePostSlug: string, listIdx: number, itemIdx: number): AdvancedArticleCreateEditRemoveItemTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_REMOVE_ITEM_TRIGGER, username, articlePostSlug, listIdx, itemIdx,
    });

///////////////////////////////////////////////////////////////////
// AdvancedArticleCreateEdit load

export const ADVANCED_ARTICLE_CREATE_EDIT_FETCH_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_FETCH_TRIGGER';
export interface AdvancedArticleCreateEditFetchTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_FETCH_TRIGGER;
    readonly username: string;
    readonly advancedArticleTypeSlug: string;
    readonly articlePostSlug: string;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_FETCH_REQUEST = 'ADVANCED_ARTICLE_CREATE_EDIT_FETCH_REQUEST';
export interface AdvancedArticleCreateEditFetchRequestAction extends APIRequestAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_FETCH_REQUEST;
    readonly username: string;
    readonly articlePostSlug: string;
}
export interface AdvancedArticleCreateEditFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post?: number;
        advancedArticleListItemDetails?: number[];
        advancedArticleCategories: number[];
    };
}
export const ADVANCED_ARTICLE_CREATE_EDIT_FETCH_SUCCESS = 'ADVANCED_ARTICLE_CREATE_EDIT_FETCH_SUCCESS';
export interface AdvancedArticleCreateEditFetchSuccessAction extends APISuccessAction<AdvancedArticleCreateEditFetchNormalizedResponse> {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_FETCH_SUCCESS;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly listItemMapping: Record<number, number[]>;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_FETCH_FAILURE = 'ADVANCED_ARTICLE_CREATE_EDIT_FETCH_FAILURE';
export interface AdvancedArticleCreateEditFetchFailureAction extends APIFailureAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_FETCH_FAILURE;
    readonly username: string;
    readonly articlePostSlug: string;
}

export const advancedArticleCreateEditFetchTrigger =
    (username: string, advancedArticleTypeSlug: string, articlePostSlug: string): AdvancedArticleCreateEditFetchTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_FETCH_TRIGGER, username, advancedArticleTypeSlug, articlePostSlug,
    });
export const advancedArticleCreateEditFetchApi = {
    request: (username: string, articlePostSlug: string): AdvancedArticleCreateEditFetchRequestAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_FETCH_REQUEST, username, articlePostSlug,
    }),
    success: (username: string, articlePostSlug: string, listItemMapping: Record<number, number[]>, response: AdvancedArticleCreateEditFetchNormalizedResponse): AdvancedArticleCreateEditFetchSuccessAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_FETCH_SUCCESS, username, articlePostSlug, listItemMapping, response,
    }),
    failure: (username: string, articlePostSlug: string, error: any): AdvancedArticleCreateEditFetchFailureAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_FETCH_FAILURE, username, articlePostSlug, error,
    }),
};

///////////////////////////////////////////////////////////////////
// AdvancedArticleCreateEdit Change Editor

export const ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER';
export interface AdvancedArticleCreateEditChangeEditorTypeTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly editorType: number;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_REQUEST = 'ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_REQUEST';
export interface AdvancedArticleCreateEditChangeEditorTypeRequestAction extends APIRequestAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_REQUEST;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly editorType: number;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS = 'ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS';
export interface AdvancedArticleCreateEditChangeEditorTypeSuccessAction extends APISuccessAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly editorType: number;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_FAILURE = 'ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_FAILURE';
export interface AdvancedArticleCreateEditChangeEditorTypeFailureAction extends APIFailureAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_FAILURE;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly editorType: number;
}

export const advancedArticleCreateEditChangeEditorTypeTrigger =
    (username: string, articlePostSlug: string, editorType: number): AdvancedArticleCreateEditChangeEditorTypeTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER, username, articlePostSlug, editorType,
    });
export const advancedArticleCreateEditChangeEditorTypeApi = {
    request: (username: string, articlePostSlug: string, editorType: number): AdvancedArticleCreateEditChangeEditorTypeRequestAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_REQUEST, username, articlePostSlug, editorType,
    }),
    success: (username: string, articlePostSlug: string, editorType: number, response: any): AdvancedArticleCreateEditChangeEditorTypeSuccessAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS, username, articlePostSlug, editorType, response,
    }),
    failure: (username: string, articlePostSlug: string, editorType: number, error: any): AdvancedArticleCreateEditChangeEditorTypeFailureAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_CHANGE_EDITOR_TYPE_FAILURE, username, articlePostSlug, editorType, error,
    }),
};

///////////////////////////////////////////////////////////////////
// AdvancedArticleCreateEdit Save Article

export const ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_TRIGGER';
export interface AdvancedArticleCreateEditSaveArticleTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_TRIGGER;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly articleId: number;
    readonly advancedArticleFormData: AdvancedArticleCreateEditFormData;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_REQUEST = 'ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_REQUEST';
export interface AdvancedArticleCreateEditSaveArticleRequestAction extends APIRequestAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_REQUEST;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly articleId: number;
    readonly advancedArticleFormData: AdvancedArticleCreateEditFormData;
}
export interface AdvancedArticleCreateEditSaveNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
    };
}
export const ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_SUCCESS = 'ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_SUCCESS';
export interface AdvancedArticleCreateEditSaveArticleSuccessAction extends APISuccessAction<AdvancedArticleCreateEditSaveNormalizedResponse> {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_SUCCESS;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly articleId: number;
    readonly advancedArticleFormData: AdvancedArticleCreateEditFormData;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_FAILURE = 'ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_FAILURE';
export interface AdvancedArticleCreateEditSaveArticleFailureAction extends APIFailureAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_FAILURE;
    readonly username: string;
    readonly articlePostSlug: string;
    readonly articleId: number;
    readonly advancedArticleFormData: AdvancedArticleCreateEditFormData;
}

export const advancedArticleCreateEditSaveArticleTrigger =
    (username: string, articlePostSlug: string, articleId: number, advancedArticleFormData: AdvancedArticleCreateEditFormData): AdvancedArticleCreateEditSaveArticleTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_TRIGGER, username, articlePostSlug, articleId, advancedArticleFormData,
    });
export const advancedArticleCreateEditSaveArticleApi = {
    request: (username: string, articlePostSlug: string, articleId: number, advancedArticleFormData: AdvancedArticleCreateEditFormData): AdvancedArticleCreateEditSaveArticleRequestAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_REQUEST, username, articlePostSlug, articleId, advancedArticleFormData,
    }),
    success: (username: string, articlePostSlug: string, articleId: number, advancedArticleFormData: AdvancedArticleCreateEditFormData, response: AdvancedArticleCreateEditSaveNormalizedResponse): AdvancedArticleCreateEditSaveArticleSuccessAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_SUCCESS, username, articlePostSlug, articleId, advancedArticleFormData, response,
    }),
    failure: (username: string, articlePostSlug: string, articleId: number, advancedArticleFormData: AdvancedArticleCreateEditFormData, error: any): AdvancedArticleCreateEditSaveArticleFailureAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_SAVE_ARTICLE_FAILURE, username, articlePostSlug, articleId, advancedArticleFormData, error,
    }),
};

///////////////////////////////////////////////////////////////////
// AdvancedArticleCreateEdit Insert image

export const ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_TRIGGER = 'ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_TRIGGER';
export interface AdvancedArticleCreateEditInsertImageTriggerAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_TRIGGER;
    readonly editor: any;
    readonly formName: string;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
    readonly processPhotoUploadOnFormPage: FormPageType;
    readonly accessKey?: string;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_REQUEST = 'ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_REQUEST';
export interface AdvancedArticleCreateEditInsertImageRequestAction extends APIRequestAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_REQUEST;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
}
export interface AdvancedArticleCreateEditInsertImageNormalizedResponse extends NormalizedResponse {
    readonly result: number;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_SUCCESS = 'ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_SUCCESS';
export interface AdvancedArticleCreateEditInsertImageSuccessAction extends APISuccessAction<AdvancedArticleCreateEditInsertImageNormalizedResponse> {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_SUCCESS;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
    readonly response: AdvancedArticleCreateEditInsertImageNormalizedResponse;
}
export const ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_FAILURE = 'ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_FAILURE';
export interface AdvancedArticleCreateEditInsertImageFailureAction extends APIFailureAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_FAILURE;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
}

export const advancedArticleCreateEditInsertImageTrigger =
    (editor: any, formName: string, config: PhotosUploadConfig, files: File[], processPhotoUploadOnFormPage: FormPageType, accessKey?: string): AdvancedArticleCreateEditInsertImageTriggerAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_TRIGGER, editor, formName, config, files, processPhotoUploadOnFormPage, accessKey,
    });
export const advancedArticleCreateEditInsertImageApi = {
    request: (config: PhotosUploadConfig, files: File[]): AdvancedArticleCreateEditInsertImageRequestAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_REQUEST, config, files,
    }),
    success: (config: PhotosUploadConfig, files: File[], response: AdvancedArticleCreateEditInsertImageNormalizedResponse): AdvancedArticleCreateEditInsertImageSuccessAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_SUCCESS, config, files, response,
    }),
    failure: (config: PhotosUploadConfig, files: File[], error: any): AdvancedArticleCreateEditInsertImageFailureAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_INSERT_IMAGE_FAILURE, config, files, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Set prefill data (for creating recipe from group post)

export interface PrefillData {
    photos?: UploadedPhoto[];
    oneliner?: string;
    sourcePostId?: number;
}

export const ADVANCED_ARTICLE_CREATE_EDIT_SET_PREFILL_DATA = 'ADVANCED_ARTICLE_CREATE_EDIT_SET_PREFILL_DATA';
export interface AdvancedArticleCreateEditSetPrefillDataAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_SET_PREFILL_DATA;
    readonly data: PrefillData;
}
export const advancedArticleCreateEditSetPrefillData =
    (data: PrefillData): AdvancedArticleCreateEditSetPrefillDataAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_SET_PREFILL_DATA, data,
    });

export const ADVANCED_ARTICLE_CREATE_EDIT_CLEAR_PREFILL_DATA = 'ADVANCED_ARTICLE_CREATE_EDIT_CLEAR_PREFILL_DATA';
export interface AdvancedArticleCreateEditClearPrefillDataAction {
    readonly type: typeof ADVANCED_ARTICLE_CREATE_EDIT_CLEAR_PREFILL_DATA;
}
export const advancedArticleCreateEditClearPrefillData =
    (): AdvancedArticleCreateEditClearPrefillDataAction => ({
        type: ADVANCED_ARTICLE_CREATE_EDIT_CLEAR_PREFILL_DATA,
    });
